import { api } from '../../../../../lib/api';

export const deleteTile = tileId =>
  api({
    method: 'delete',
    url: `/api/client_admin/tiles/destroy_tiles`,
    data: { tile: { ids: tileId } },
  });

export const copyTile = tileId =>
  api({
    method: 'post',
    url: `/api/client_admin/campaigns/tiles/${tileId}/copy`,
  });

export const updateTile = ({ tileId, tileStatus }) =>
  api({
    method: 'patch',
    url: `/api/client_admin/tile/${tileId}`,
    data: {
      tile: { status: tileStatus },
    },
  });
